// formula_validator.js
// Designer-side: parse-only check + variable extraction.
// Returns: { ok: Boolean, vars: String[], error?: String }

import { Parser } from "expr-eval";

const parser = new Parser({
  operators: {
    add: true, subtract: true, multiply: true, divide: true, remainder: true,
    power: false, factorial: false, comparison: false, logical: false,
    in: false, assignment: false, conditional: false,
  },
});

export function validateFormulaSyntax(formula) {
  if (!formula || typeof formula !== "string" || formula.trim() === "") {
    return { ok: true, vars: [] };
  }
  if (/^[\d.,\s\-+]+$/.test(formula.trim())) {
    return { ok: true, vars: [] };
  }
  try {
    // Convert German decimal commas to points first
    const normalized = formula.replace(/(\d),(\d)/g, "$1.$2");
    const parsed = parser.parse(normalized);
    return { ok: true, vars: parsed.variables() };
  } catch (e) {
    return { ok: false, vars: [], error: e.message };
  }
}

// Validate that all variables referenced in formula are declared as calcFormulaId
// somewhere on the same task's formFields.
export function findUnknownVars(formula, currentFormFields, currentFormFieldId) {
  const { ok, vars } = validateFormulaSyntax(formula);
  if (!ok) return [];
  const knownIds = (currentFormFields || [])
    .filter((ff) => ff && ff._id !== currentFormFieldId)
    .map((ff) => ff.calcFormulaId)
    .filter((id) => id && id.length > 0);
  return vars.filter((v) => !knownIds.includes(v));
}
